import React from 'react';

const PropertyFeatures = ({ features }) => (
	<div>
		<div className="property-detail-feature-list clearfix mb-0">
			<ul>
				{features?.map((feature, index) => (
					<li key={index}>
						<div className="property-detail-feature-list-item">
							<i className="flaticon-double-bed" />
							<div>
								<h6>{feature.label}</h6>
								<small>{feature.value}</small>
							</div>
						</div>
					</li>
				))}
			</ul>
		</div>
	</div>
);

export default PropertyFeatures;